<template>
    <b-card title="All User Email"> 
        <div class="mt-3 mb-5">
            <div class="activity-content">
                <h7 class="title-width">Subject</h7> 
                <b-form-input class="box-width" id="name-input" type="text" v-model="modify.subject" />
            </div>
            <div class="activity-content mt-2">
                <h7 class="title-width">Body</h7> 
                <b-form-textarea class="box-width" id="name-input" row="6" type="text" v-model="modify.body" />
            </div>
            <b-button class="mt-2" variant="primary" @click="submitNotification()" :disabled="submitLoading">Submit</b-button>
        </div>

        <!-- <p style="font-size: 18px; font-weight: 500;">Previous Emails</p>
        <vue-good-table
            :columns="columns"
            :rows="rows"
            :rtl="direction"
            styleClass="vgt-table striped condensed no-outline"
        >
            <template
                slot="table-row"
                slot-scope="props"
            >
                <span
                    v-if="props.column.field === 'subject'"
                    class="text-nowrap"
                >
                    <span class="text-nowrap">{{ props.row.subject }}</span>
                </span>

                <span
                    v-else-if="props.column.field === 'body'"   
                    style="width: 100%; text-align: center; display: flex; justify-content: center; align-items: center;"
                >
                    <p style="min-width: 400px; max-width: 600px; white-space: normal;">{{ props.row.body }}</p>
                </span>

                <span
                    v-else-if="props.column.field === 'created_at'"
                    class="text-nowrap"
                >
                    <span>{{ formatTimestamp(props.row.created_at) }}</span>
                </span>

                <span v-else-if="props.column.field === 'index'">
                    <span>{{props.row.originalIndex+1}}</span>
                </span>
        
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table> -->
    </b-card>
</template>

<script> 

import {
BAvatar,BButton, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BCard,
BModal,VBModal,BCardText, BFormTextarea
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import vSelect from "vue-select"
import Ripple from "vue-ripple-directive";
import {mapState} from "vuex";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
    components: {
        VueGoodTable,
        BAvatar,
        BCard,
        BBadge,
        BButton,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
        BModal,
        vSelect,
        BCardText,
        BFormTextarea
    },

    directives: {
        'b-modal': VBModal,
        Ripple,
    },

    data() {
        return {
            rows: [],
            dir: false,
            modify: {
                subject: null,
                body: null,
                // payload: null
            },
            columns: [
                {
                    label: '#',
                    field: 'index',
                    type:'number',
                    tdClass: 'text-center',
                    thClass:'text-center'
                },
                {
                    label: 'Subject',
                    field: 'subject',
                    tdClass: 'text-center',
                    thClass:'text-center'
                },
                {
                    label: 'Body',
                    field: 'body',
                    tdClass: 'text-center',
                    thClass:'text-center'
                },
                {
                    label: 'Date & Time', 
                    field: 'created_at',
                    tdClass: 'text-center',
                    thClass:'text-center'
                }
            ]
        }
    },

    computed: {
        ...mapState('settings', ["allUserEmail","categoriesError","categoriesLoading", "submitError","submitSuccess","submitLoading"])
    },

    watch: {
        allUserEmail(newValue, oldValue) {
            if (newValue) {
                this.rows = this.allUserEmail
            }
        }
    },

    created() {
        this.$store.dispatch('settings/getallUserEmail')
        this.rows = this.allUserEmail
    },

    methods: {
        formatTimestamp(value) {
            if (!value) return ''
            return moment(value).format('MMMM Do YYYY, hh:mm:ss A')
        },

        submitNotification() {
            this.$store.dispatch('settings/pushAllUserEmail', this.modify)
            .then(result=>{
                if(result.code == 200) {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `Success`,
                            icon: 'ThumbsUpIcon',
                            variant: 'success',
                            text: result.status
                        }
                    })
                    this.modify.subject = null
                    this.modify.body = null
                } else {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `Error`,
                            icon: 'ThumbsDownIcon',
                            variant: 'error',
                            text: result.message
                        }
                    })
                }
            }) 
        }
    }
}
</script>
  
<style lang="scss" scoped>
.no-outline{
    border:none !important;
}

.f20{
    font-size: 8px !important;
}

.vs__dropdown-menu {
    height: 200px;
}

.activity-content {
    font-size: medium;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.box-width {
    width: 600px;
}

@media screen and (max-width: 640px) {
    .box-width {
        width: 100%;
    }
}

@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';

</style>